const itinerary = {
    scrollToContinue: 'Scorri per continuare',
    expand: 'Espandi',
    closeMediaViewer: 'Chiudi visualizzatore media',
    previousMedia: 'Media precedente',
    nextMedia: 'Media successiva',
    pdfDownload: 'Scarica la versione PDF con maggiori dettagli sul viaggio',
    pdfEnglish: 'in inglese',
    pdfDutch: 'in olandese',
    pdfAnd: 'e',
    contactInfo: 'Per maggiori informazioni è possibile contattare direttamente il nostro staff tramite',
    contactForm: 'form di contatto',
    contactEmail: 'o inviando email a',
    contactEmailAddress: 'info@ladolcevitareis.nl'
};

export default itinerary;
